// general components
import PointOfContact from "containers/request/Initial/Steps/Vendor/PointOfContact";
import Billing from "containers/request/Initial/Steps/Vendor/Billing";

// ECO related components
import SelectModel from "containers/request/ECO/SelectModel";
import ModelInfo from "containers/request/ECO/ModelInfo";
import LabInfoECO from "containers/request/ECO/LabInfo";
import DocumentsECO from "containers/request/ECO/Documents";

// Initial related components
import DeviceInfo from "containers/request/Initial/Steps/Vendor/DeviceInfo";
import LabInfo from "containers/request/Initial/Steps/Vendor/LabInfo";
import LicenseAgreement from "containers/request/Initial/Agreements/index";
import Documents from "containers/request/Initial/Steps/Vendor/Documents";

// Rebrand related components
import RebrandSelectModel from "containers/request/Rebrand/RebrandSelectModel";
import RebrandInfo from "containers/request/Rebrand/RebrandInfo";
import RebrandDocs from "containers/request/Rebrand/RebrandDocs";
import RebrandAgreement from "containers/request/Rebrand/RebrandAgreement";

export const ecoTabs = {
  1: SelectModel,
  2: ModelInfo,
  3: PointOfContact,
  4: Billing,
  5: LabInfoECO,
  6: DocumentsECO
};

export const initialTabs = {
  1: DeviceInfo,
  2: PointOfContact,
  3: Billing,
  4: LabInfo,
  5: Documents,
  6: LicenseAgreement
};

export const rebrandTabs = {
  1: RebrandSelectModel,
  2: RebrandInfo,
  3: PointOfContact,
  4: Billing,
  5: RebrandDocs,
  6: RebrandAgreement
};



// WEBPACK FOOTER //
// ./src/helpers/WizardHelper.js